import { OnInit, OnDestroy } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { UserService } from '../aplication/api/Services/User.service';
import { UserDto } from '../aplication/api/Manipulate/UserDto';
import { AuthService } from '../aplication/service/auth.service';
import { CustomJwtPayload } from '../auth.guard';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit, OnDestroy {

    model: any[] = [];
    userRole?:string;
    private routerSubscription: Subscription | undefined;

    constructor(public layoutService: LayoutService, private router: Router,) { }

    ngOnInit() {
        const token = localStorage.getItem('authTokenLicitaAdmin');
        
        if (token) {
            const decodedToken = jwtDecode<CustomJwtPayload>(token); // Usando a interface personalizada aqui
            this.userRole = decodedToken.role;  
        }
        this.initializeMenu();


        // Subscribe to router events
        this.routerSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                setTimeout(() => {
                    this.resetMenu();
                }, 1000);
                 // Reset the menu on navigation end
            }
        });
    }

    ngOnDestroy() {
        // Unsubscribe to avoid memory leaks
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

    initializeMenu() {
        this.model = [
            // {
            //     label: 'PROCESSOS',
            //     items: [
            //         { label: 'Meus Processos', icon: 'pi pi-book', routerLink: ['licita/processos'], visible: true },
                    
            //         // { label: 'Disputas', icon: 'pi pi-hammer', routerLink: ['licita/dispute'], visible: true },
            //         // { label: 'Itens Cotados', icon: 'pi pi-box', routerLink: ['licita/offer-items'], visible: true },
            //         // { label: 'Ordens de Compra', icon: 'pi pi-shopping-cart', routerLink: ['licita/purchase-order'], visible: true },
            //         // { label: 'Arquivados', icon: 'pi pi-inbox', routerLink: ['licita/archived-processes'], visible: true },
            //         // { label: 'Lumy', icon: 'pi pi-sparkles', routerLink: ['licita/lumy'], visible: true },
            //     ]
            // },
            // {
            //     label: 'CADASTROS',
            //     items: [
            //         { label: 'Itens', icon: 'pi pi-cart-plus', routerLink: ['licita/items'], visible: true },
            //         { label: 'Empresas', icon: 'pi pi-building', routerLink: ['licita/company'], visible: ['Manager','Owner'].includes(this.userRole!) },
            //     ]
            // },
            // {
            //     label: 'ARMAZENAMENTO',
            //     items: [
            //         { label: 'Storage', icon: 'pi pi-cloud', routerLink: ['licita/storage'], visible: true },
            //     ]
            // },
            {
                label: ['Manager','Owner'].includes(this.userRole!) ? 'ADMINISTRATIVO':'',
                items: [
                    { label: 'Planos', icon: 'pi pi-book', routerLink: ['licita/users'], visible: ['SuperUser'].includes(this.userRole!) },
                    { label: 'Cursos', icon: 'pi pi-crown', routerLink: ['licita/courses'], visible: ['SuperUser'].includes(this.userRole!) },
                    { label: 'Parceiro', icon: 'pi pi-users', routerLink: ['licita/partners'], visible: ['SuperUser'].includes(this.userRole!) },
                    { label: 'Faker Users', icon: 'pi pi-user-edit', routerLink: ['licita/faker-users'], visible: ['SuperUser'].includes(this.userRole!) },
                    { label: 'Uso da equipe', icon: 'pi pi-chart-bar', routerLink: ['licita/audit'], visible: ['Manager','Owner','SuperUser'].includes(this.userRole!) },
                    { label: 'Help Hub', icon: 'pi pi-question-circle', routerLink: ['licita/help'], visible: ['SuperUser'].includes(this.userRole!) },
                    { label: 'Chat de Suporte', icon: 'pi pi-comments', routerLink: ['licita/support-chat'], visible: ['SuperUser'].includes(this.userRole!) },
                    //{ label: 'SINAPI', icon: 'pi pi-building-columns', routerLink: ['licita/sinapi'], visible: ['SuperUser'].includes(this.userRole!) },
                    // { label: 'Solicitantes', icon: 'pi pi-envelope', routerLink: ['licita/solicitantes'], visible: ['SuperUser'].includes(this.userRole!) },
                    // { label: 'Dashboard', icon: 'pi pi-chart-pie', routerLink: ['licita/dashboard'], visible: ['Manager','Owner'].includes(this.userRole!) },
                ]
                
            },
        ];
    }

    resetMenu() {
        // Logic to reset menu state can be added here if needed
        //console.log('Menu reset'); // For debugging purposes
        this.initializeMenu(); // Reinitialize the menu
    }
}
